import React from "react";
import CoursePlayer from "../course/course-player";

const TechCoursePlayer = ({ course, title }) => {
  return (
    <div className="w-full">
      {title && <h3 className="text-xl font-medium mb-4 text-center">{title}</h3>}
      <CoursePlayer course={course} />
    </div>
  );
};

export default TechCoursePlayer;
